<template>
  <div>
    <div>
      <v-row align="center" style="margin: 20px">
        <v-col class="d-flex" cols="8" sm="8" lg="7">
          <v-col class="d-flex" cols="3" sm="3" lg="3">
            <span>نوع فعالیت </span>
          </v-col>
          <v-col class="d-flex" cols="9" sm="5" lg="5">
            <v-select
              :items="resumeCategory"
              item-text="text"
              item-value="value"
              v-model="category"
              return-object
            ></v-select>
          </v-col>
        </v-col>
        <v-col class="d-flex" cols="12" sm="2" lg="2">
          <v-btn
            class="grid"
            color="green white--text"
            rounded
            @click="goToRoute(`${detailRoute}`)"
          >
            {{ "رتبه بندی رزومه" }}
          </v-btn>
          <v-btn
            style="margin-right: 5px"
            class="grid"
            color="green white--text"
            rounded
            @click="openRahnama"
          >
            {{ "راهنمای ثبت رزومه" }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <app-category :categories="filteredCategoryItems" @click="clickHandler" />
  </div>
</template>

<script>
import categoryItems from "./CategoryItems";

export default {
  props: ["categories"],
  components: {
    appCategory: categoryItems,
  },
  data() {
    return {
      detailRoute: "/resume/reportCard",
      resumeCategory: [
        { value: "all", text: "همه موارد" },
        { value: "general", text: "عمومی" },
        { value: "Pajohesh", text: "پژوهشی" },
        { value: "tabliq", text: "تبلیغی" },
        { value: "sport", text: "ورزشی" },
      ],
      category: { value: "all", text: "همه موارد" },
    };
  },
  computed: {
    filteredCategoryItems() {
      return this.category.value !== "all"
        ? this.categories.filter(
            (item) => item.Category === this.category.value
          )
        : this.categories;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    openRahnama() {
      window.open("https://hozehkh.com/res/resumerahnama.pdf");
    },
    clickHandler(param) {
      this.$emit("click", param);
    },
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
.backgroundGlobal {
  background-color: #e8e8e8 !important;
}
</style>
